import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export const useBreakpointsComposable = () => {
    const breakpoints = useBreakpoints(breakpointsTailwind)
    return {
        isSmallScreen: breakpoints.smallerOrEqual('sm').value,
        breakpoints,
    }
}